module.exports = __webpack_public_path__ + "img/bg-sm-07.f17a0cc2.jpg";